import { Locale } from "@linkfluence/models/locale";
import { FullFacet } from "@radarly/models/facets";
import { RadarlyAPI } from "./base";
import { GeoAPI } from "./geo";
import { OccupationsAPI } from "./occupations";

interface Dependencies {
  occupationsAPI: OccupationsAPI;
  geoAPI: GeoAPI;
}

export class ClauseAPI extends RadarlyAPI {
  private occupationsAPI: OccupationsAPI;
  private geoAPI: GeoAPI;
  constructor(dependencies: Dependencies) {
    super();
    this.occupationsAPI = dependencies.occupationsAPI;
    this.geoAPI = dependencies.geoAPI;
  }

  public getBrandLogos(ids: (number | string)[]) {
    return this.post<FullFacet["values"]>("/brand-logos/list.json", { ids });
  }
  public getCelebrities(ids: (number | string)[]) {
    return this.post<FullFacet["values"]>("/person-identification/list.json", {
      ids,
    });
  }
  public getOccupations(ids, locale: Locale) {
    return this.occupationsAPI.getOccupations(ids, locale);
  }
  public getTowns(focuses: number[], projectID: number, locale: Locale) {
    return this.geoAPI.getTowns(focuses, projectID, locale);
  }
}
